import Dashboard from '@/views/Dashboard/Index'

export default [
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            title: 'Dashboard',
            menuRendered: true,
            menuTitle: 'Dashboard',
            requiresAuth: true,
            icon: 'mdi-view-dashboard',
        }
    }
]
